// OpenInpFileHeadless.jsx
import { SwmmConvert } from "@fileops/swmm-node"

/**
 * 
 * @param {function} setModel sets the swmm model in JSON format
 * @param {function} setSwmmTxt sets the swmm model .inp file contents in string format
 * @param {function} setSwmmOut sets the swmm .out file contents
 * @param {function} setRpt sets the .rpt file contents in string format
 * @param {function} setLoadModel sets loadModel flag, signals to other components that a new model has been loaded and old results invalidated.
 * @param {function} closeAll closes all dialogs that relate input and output for the model and interface.
 * @returns Object containing a function for opening a swmm .inp file and setting default map display information.
 */
const OpenInpFileHeadless = (setModel, setSwmmTxt, setSwmmOut, setRpt, setLoadModel, closeAll) => {
  const showFile = async (e) => {
    closeAll()
    e.preventDefault()
    setSwmmOut(undefined)
    setRpt('')
    const reader = new FileReader()
    reader.onload = async (e) => {
      const text = e?.target?.result
      // Translate the text to a swmmjs object.
      let jsonSWMM = SwmmConvert.parseInput(text)
      // If there isn't a PCS and TRANSFORM section in the file, add them
      if(jsonSWMM.PCS == null){
        jsonSWMM.PCS = {
          swmmNode_proj: {
              "proj": "utm",
              "zone": "19",
              "datum": "WGS84",
              "units": "ft",
              "defs": "no_defs"
          }
        }
      }
      if( jsonSWMM.TRANSFORM == null ){
        jsonSWMM.TRANSFORM = {
          swmmNode_t: {
            "x": 1661000,
            "y": 4378000,
            "size": 1,
            "rotation": 0
          }
        }
      }
      if(jsonSWMM.MAP == null){
        jsonSWMM.MAP = {
          "DIMENSIONS": {
              "x1": 0,
              "y1": 0,
              "x2": 10000,
              "y2": 10000
          },
          "Units": "None"
        }
      }
      setSwmmTxt(text)
      setModel(jsonSWMM)
      setLoadModel(prev => prev + 1)
    }
    reader.readAsText(e.target.files[0])
  }

  return { showFile }
}
 
export default OpenInpFileHeadless